import { opening, type MarkThreadDto } from '@nsb/core';

/**
 * The markup page's words and addresses, pure so they are tested in Node (design study 29).
 */

/** How much of a resolved comment its folded line opens with: one line beside its number in the comments' column. */
export const FOLD_AT = 40;

/**
 * A resolved comment's folded line (fold A; Jason, 2026-10-28: "maybe it just folds the comment up with a single line of
 * the text ending in ..."): the start of its words by core `opening`, the timeline's own rule, or what it is when it has none.
 */
export function foldedWords(t: Pick<MarkThreadDto, 'root' | 'replies'>): string {
  const words = t.root.body?.trim() || t.replies.find((r) => r.body?.trim())?.body?.trim();
  return words ? opening(words, FOLD_AT) : 'A mark with no words';
}

/** A sheet's own page in its review, opened on one of its comments when given. */
export const sheetPage = (projectId: string, fileId: string, thread?: string) => `/p/${projectId}/reviews/files/${fileId}${thread ? `?thread=${thread}` : ''}`;
